import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-[#F9F7F4] flex flex-col">
      {/* Minimal nav so crawlers can follow links back into the site */}
      <header className="bg-white border-b border-gray-100 shadow-sm">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-shield-check-fill text-[18px] text-[#D97642]"></i>
            </div>
            <span className="text-lg font-bold text-[#1A3A52] tracking-tight whitespace-nowrap">
              Hoosier Life Insurance
            </span>
          </Link>
          <nav className="flex items-center gap-4 text-sm">
            <Link to="/" className="text-gray-600 hover:text-[#D97642] font-medium transition-colors">Home</Link>
            <Link to="/service-areas" className="text-gray-600 hover:text-[#D97642] font-medium transition-colors">Service Areas</Link>
            <a href="tel:+13176482983" className="px-4 py-2 bg-[#D97642] text-white rounded-lg hover:bg-[#C26638] transition-colors whitespace-nowrap font-semibold">
              (317) 648-2983
            </a>
          </nav>
        </div>
      </header>

      <div className="flex-1 flex flex-col items-center justify-center text-center px-4 relative overflow-hidden">
        <span className="absolute text-[14rem] font-black text-gray-100 select-none pointer-events-none z-0 leading-none">
          404
        </span>
        <div className="relative z-10 max-w-lg">
          <div className="w-20 h-20 bg-[#D97642]/10 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-map-pin-off-line text-4xl text-[#D97642]"></i>
          </div>
          <h1 className="text-2xl md:text-3xl font-bold text-[#1A3A52] mb-3">Page Not Found</h1>
          <p className="text-gray-500 font-mono text-sm mb-2">{location.pathname}</p>
          <p className="text-gray-500 text-base mb-8">
            The page you're looking for doesn't exist or may have moved.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#1A3A52] text-white font-semibold rounded-lg hover:bg-[#14304A] transition-colors whitespace-nowrap"
            >
              <i className="ri-home-line"></i>
              Back to Home
            </Link>
            <Link
              to="/service-areas"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white border border-gray-200 text-[#1A3A52] font-semibold rounded-lg hover:bg-gray-50 transition-colors whitespace-nowrap"
            >
              <i className="ri-map-pin-line"></i>
              Service Areas
            </Link>
            <a
              href="tel:+13176482983"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#D97642] text-white font-semibold rounded-lg hover:bg-[#C26638] transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line"></i>
              Call Us
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
